import { render, staticRenderFns } from "./NotesCard.vue?vue&type=template&id=363cbe44"
import script from "./NotesCard.vue?vue&type=script&lang=ts"
export * from "./NotesCard.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/codebuild/output/src4020427597/src/jobbliss-app-vue/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('363cbe44')) {
      api.createRecord('363cbe44', component.options)
    } else {
      api.reload('363cbe44', component.options)
    }
    module.hot.accept("./NotesCard.vue?vue&type=template&id=363cbe44", function () {
      api.rerender('363cbe44', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/projects/activities/NotesCard.vue"
export default component.exports